<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name:
    "views-administrator-backoffice-accountabilityOnline-withdrawsAndDeposits",
  data: () => ({}),
  mounted() {
    if (this.$route.name === "BankOnline") {
      this.$router.push({
        name: "AdministratorAccountabilityOnlineBankStatement",
      });
    }
  },
  watch: {
    /*
      Esse watch previne um bug que ocorre quando Depósitos e Saques
      é clicado novamente
    */
    $route(val){
      if (val.name === "BankOnline") {
        this.$router.push({
        name: "AdministratorAccountabilityOnlineBankStatement",
      });
      }
    }
  }
};
</script>
